<template>
  <el-col :span="23">
    <el-form
      ref="form"
      :model="form"
      label-width="140px"
      class="form"
      v-if="project.name"
    >
      <create-invite3
        ref="create"
        :project="project"
        :projectArr="projectArr"
        :teamArr="teamArr"
        :userData="userData"
        :formByFather="form"
      ></create-invite3>

      <div class="tip" style="margin: 20px 0 0 40px">* 相关附件</div>
      <div class="clear">
        <el-form-item label="上传附件">
          <attachments
            :projectId="form.projectId"
            :contractId="form.contractId"
            ref="attachments"
            :arr="attachmentArr"
            :type="4"
          ></attachments>
        </el-form-item>
      </div>

      <div class="tip" style="margin: 20px 0 0 40px">* 意见与审批</div>
      <div class="clear label-mx">
        <el-form-item label="审批方式">
          <div class="approve">
            <el-radio v-model="approvalType" label="0">顺序审批</el-radio>
            <el-radio v-model="approvalType" label="1">平行审批</el-radio>
          </div>
        </el-form-item>

        <!-- 审批 -->
        <approval-item
          ref="approval"
          :approvalUsers="approvalUsers.c4_2"
          :selectArr="selectArr"
          :approvalSetDep="approvalSetDep"
        ></approval-item>
      </div>
      
      <div class="tip tip-table">
        <p>
          <span class="tip-lable">注：</span
          >1、本表适用于工程项目招标控制价的申请报批，由项目招标实施部门填写审核后的招标控制价，内控法务部审核后报集团公司相关部门批准后由资产运营部按照审批的控制价进行招标工作。
        </p>
        <p>2、上报时附招标控制价文本及相关证明材料。</p>
        <p>3、本表在条件许可情况下6个工作日内办结。</p>
      </div>

      <el-form-item label="">
        <div class="form-btn-room">
          <el-button
            :loading="formLoading"
            @click="createProject()"
            class="form-btn"
            type="success"
            >确认提交项目招标控制价审批</el-button
          >
        </div>
      </el-form-item>
    </el-form>

    <!-- 保存草稿 -->
    <auto-save
      :form="form"
      :saveName="'Invite3'"
      @getForm="getFormData"
      @updateForm="updateForm"
    ></auto-save>
  </el-col>
</template>

<script>
import { mapState } from "vuex";
import Attachments from "@/components/Attachments";
import approvalUsers from "@/Mixins/approvalUsers";

import ApprovalItem from "@/components/ApprovalItem";
import CreateInvite3 from "@/page/form/createInvite3";

import AutoSave from "@/components/AutoSave";
import saveForm from "@/Mixins/saveForm";

import ObjectUtil from "../mixins/objectUtil";
export default {
  components: {
    ApprovalItem,
    CreateInvite3,
    Attachments,
    AutoSave,
  },
  props: ["projectId", "teamArr", "projectArr"],
  mixins: [approvalUsers, saveForm, ObjectUtil],
  computed: {
    ...mapState({
      userData: (state) => state.main.userData,
    }),
  },
  data() {
    return {
      project: {},
      form: {
        projectId: "",
        type: "",
        lxpwh: "",
        gcjsgm: "",
        jsxz: "",
        gczy: "",

        ztz: "",
        jagcf: "",
        jaf: "",
        jgcl: "",
        zbkzj: "",

        sjdw: "",
        bzdw: "",
        gcde: "",
        jjfs: "",
        tbfs: "",
        jgxx: "",

        // 是否线下审批通过
        underLine: "",
      },
      // 附件
      attachmentArr: [],
      // 审批
      approvalType: "0",
      formLoading: false,

      applyInfo: "",
    };
  },
  created() {
    this.getApplyData();
  },
  mounted() {
    this.form.projectId = this.projectId;
    this.getProject();
  },
  methods: {
    // 获取审批表原内容
    getApplyData() {
      this.form.inviteId = this.$route.params.applyId;
      if (this.form.inviteId) {
        this.formLoading = true;
        this.getProjectApplyInfo();
      } else {
        this.setSelectArr(this.applyInfo, 4, 2);
      }
    },
    // 获取原审批表内容
    getProjectApplyInfo() {
      ajax.get("/gc/project/invite/info/" + this.form.inviteId, "", (res) => {
        this.applyInfo = res.vo;

        this.form.depId = this.applyInfo.project.depId;
        this.form.leaderId = this.applyInfo.project.leader.id;
        this.form.teamId = this.applyInfo.project.team
          ? this.applyInfo.project.team.id
          : "";
        this.form.level = this.applyInfo.project.level;
        if (this.applyInfo.project.father) {
          this.form.parentProjectId = this.applyInfo.project.father.id;
        }

        this.form.lxpwh = this.applyInfo.lxpwh;
        this.form.gcjsgm = this.applyInfo.gcjsgm;
        this.form.jsxz = this.applyInfo.jsxz;
        this.form.gczy = this.applyInfo.gczy;

        this.form.ztz = this.applyInfo.ztz;
        this.form.jagcf = this.applyInfo.jagcf;
        this.form.jaf = this.applyInfo.jaf;
        this.form.jgcl = this.applyInfo.jgcl;
        this.form.zbkzj = this.applyInfo.zbkzj;

        this.form.sjdw = this.applyInfo.sjdw;
        this.form.bzdw = this.applyInfo.bzdw;
        this.form.gcde = this.applyInfo.gcde;
        this.form.jjfs = this.applyInfo.jjfs;
        this.form.tbfs = this.applyInfo.tbfs;
        this.form.jgxx = this.applyInfo.jgxx;

        // 是否线下通过审批
        this.form.underLine = this.applyInfo.underLine.toString();

        this.attachmentArr = this.applyInfo.attachments
          ? this.applyInfo.attachments
          : [];

        this.setSelectArr(this.applyInfo, 4, 2);
        this.formLoading = false;
      });
    },
    // 获取项目详情
    getProject() {
      ajax.get("/gc/project/detail/" + this.form.projectId, "", (res) => {
        this.project = res.vo;

        // 修改当前选中的侧边栏
        this.setNavType(this.project);

        this.form.ztz = this.project.xmgs;
        this.form.lxpwh = this.project.lxpwh;
      });
    },
    // 提交项目申请
    createProject() {
      this.form = this.$refs.create.getFromData();
      if (this.form.underLine == "") {
        this.$message.error("请标注本次审批是否已线下通过");
        return;
      }

      this.form.type = 2;

      this.form.approvalType = this.approvalType;
      this.form.approvalUserIds = this.$refs.approval.getUserIds();
      this.form.attachments = this.$refs.attachments.getAttachments();

      this.formLoading = true;
      let _url = !this.form.inviteId
        ? "/gc/project/invite"
        : "/gc/project/invite/edit";

      ajax.post(
        _url,
        this.form,
        (res) => {
          this.$message.success(
            "项目招标控制价审批提交成功，请耐心等待领导审批"
          );
          this.$router.back();
          this.formLoading = false;
        },
        (res) => {
          this.formLoading = false;
        }
      );
    },
  },
  watch: {},
};
</script>


// WEBPACK FOOTER //
// src/page/project/formLayout/createInvite_3.vue